import React from "react";
import { useTranslation } from "src/context/Translations/context";
import * as Matrix from "./styles";
import { IMatrixPriority } from "./interface";
import MatrixItem from "./itemMatrix";

const MatrixPriority: React.FC<IMatrixPriority> = ({
	container1,
	container2,
	container3,
	container4
}) => {

	const { translate } = useTranslation();

	return (
		<>
  	<Matrix.Wrapper>

			 	{/* Urgente | Importante */}
				<MatrixItem 
					number="1" 
					color="var(--red)"
					data={container1} 
					titles={{
						heading: translate("Faça agora"),
						title1: translate("Urgente"),
						title2: translate("Importante")
					}}
				/>

				{/* Não Urgente | Importante */}
				<MatrixItem 
					number="2" 
					color="var(--green)"
					data={container2} 
					titles={{
						heading: translate("Planeje quando fazer"),
						title1: translate("Não urgente"),
						title2: translate("Importante")
					}}
				/>
				
				{/* Urgente | Não Importante */}
				<MatrixItem 
					number="3" 
					color="var(--yellow)"
					data={container3} 
					titles={{
						heading: translate("Delegue"),
						title1: translate("Urgente"),
						title2: translate("Não importante")
					}}
				/>

				{/* Não Urgente | Não Importante */}
				<MatrixItem 
					number="4" 
					color="var(--blue)"
					data={container4} 
					titles={{
						heading: translate("Faça isso depois"),
						title1: translate("Não urgente"),
						title2: translate("Não importante")
					}}
				/>

			</Matrix.Wrapper>	
		</>
	);
};

export default MatrixPriority;
